import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {subscribeOn} from 'rxjs/operators';
import {CurrencyPipe} from '@angular/common';
import {isBoolean} from 'util';
import {ExcListComponent} from 'exc-controls';

@Injectable({
  providedIn: 'root'
})
export class DefaultSettingsService extends ExcTranslation {

  private alreadyRunning = false;
  private userSettings: string = null;
  private mandantSettings: string = null;
  private mandantConfig: string = null;
  private enumertion: string = null;
  private defaults: string = null;
  public UserSettings: {} = null;
  public MandantSettings: ExcClientSettings = null;
  public MandantConfig =  {} as any;
  public Enumeration =  {} as any;
  public Defaults = {} as any;
  public Clients: {ClientID: number, Client: string, ClientName: string}[] = [];
  public Companies: {CompanyID: number, Company: string, CompanyName: string}[] = [];
  public AllSettings: any = {}; // Record<number, IClientConfig> = {};
  private userSettingsDefault = {
    PHQColumns: [
      { col: 'DealerLevel1', span: 1},
      { col: 'DealerLevel2', span: 1},
      { col: 'DealerLevel3', span: 1},
      { col: 'DealerName', span: 2},
      { col: 'DealerZip', span: 1},
      { col: 'DealerRating', span: 1},
      { col: 'DealerCategory', span: 1},
      { col: 'AuditsPerYear', span: 1},
      { col: 'DealerStock', span: 1},
      { col: 'LastAudits', span: 3}
    ],
    PHQColumns_SFS: [
      { col: 'RRDI', span: 2},
      { col: 'Verbund', span: 2},
      { col: 'Steuernummer', span: 3},
      { col: 'Haendlername', span: 4},
    ]
  };

  constructor(private excRest: ExcRestService) {
    super();
    const _self = this;
    _self.RestoreLocal();
    ExcCoreModule.on('ExcSignIn.Ready', function() {
      // this();
      if (!_self.alreadyRunning)      {
      _self.init();
      }
    });
    ExcCoreModule.on('ExcSignIn.RevalidateToken', function() {
      // this();
      if (!_self.alreadyRunning)      {
        _self.init();
      }
    });
  }
  public getExcLabel(key: string, clientID: number, fallback?: string) {
    let lbl: string = null;
    if (this.AllSettings[clientID] !== undefined && this.AllSettings[clientID] !== null && this.AllSettings[clientID].Settings['Labels'] !== undefined
      && this.AllSettings[clientID].Settings['Labels'] !== null && this.AllSettings[clientID].Settings['Labels'][key] !== undefined) {
      lbl = this.AllSettings[clientID].Settings['Labels'][key];
    }
    if (lbl === null) {
      return fallback;
    }
    return lbl;
  }
  public getLabel(key: string) {
    let lbl: string = null;
    if (this.MandantSettings !== null && this.MandantSettings['Labels'] !== undefined
        && this.MandantSettings['Labels'] !== null && this.MandantSettings['Labels'][key] !== undefined) {
      lbl = this.MandantSettings['Labels'][key];
    }
    if (lbl === null) {
      if (key.indexOf('.') < 0) {
        key = 'Globals.' + key;
      }
      lbl = this.getTranslation(key);
    }
    return lbl;
  }
  public Reset() {
    this.init();
  }
  public LoadDefault() {
    this.UserSettings = {};
    Object.assign(this.UserSettings, this.userSettingsDefault);
  }
  public Restore() {
    if (this.userSettings !== null) {
      this.UserSettings = JSON.parse(this.userSettings);
    } else {
      this.UserSettings = {};
      Object.assign(this.UserSettings, this.userSettingsDefault);
    }
  }
  public Update() {
    const settings = JSON.stringify(this.UserSettings);
    this.excRest._postInternal(this.excRest.computeUrl('DefaultSettingsR_Summary', {}), {JSON: settings}, {}, true).subscribe(ret => {
      this.defaults = ret.data['Defaults'];
      this.mandantSettings = ret.data['MandantSettings'];
      this.userSettings = ret.data['UserSettings'];
      this.mandantConfig = ret.data['MandantConfig'];
      this.enumertion = ret.data['Enumeration'];

      if (this.userSettings !== null) {
        this.UserSettings = JSON.parse(this.userSettings);
      } else {
        this.UserSettings = {};
        Object.assign(this.UserSettings, this.userSettingsDefault);
      }
      if (this.mandantSettings !== null) {
        this.MandantSettings = JSON.parse(this.mandantSettings);
      }
      if (this.defaults !== null) {
        this.Defaults = JSON.parse(this.defaults);
      }
      if (this.mandantConfig !== null) {
        this.MandantConfig = JSON.parse(this.mandantConfig);
      }
      if (this.enumertion !== null) {
        this.Enumeration = JSON.parse(this.enumertion);
      }
    });
  }
  RestoreLocal() {
    if (this.mandantSettings === null) {
      const d = localStorage.getItem('excDss');
      if (d && d !== null) {
        const j = JSON.parse(d);
        this.UserSettings = j['U'];
        this.MandantSettings = new ExcClientSettings();
        this.MandantSettings.Apply(j['M']);
        // this.MandantSettings = j['M'];
        this.Defaults = j['D'];
        this.AllSettings = j['AS'];
        this.Clients = j['Cli'];
        this.Companies = j['Co'];
      }
    }
  }
  init() {
    this.alreadyRunning = true;
    this.excRest._getInternal(this.excRest.computeUrl('DefaultSettingsR_Summary', {}), {}, true).subscribe(ret => {
      try {
        if (ret.data['Settings']) {
          this.defaults = ret.data['Settings']['Defaults'];
          this.mandantSettings = ret.data['Settings']['MandantSettings'];
          this.userSettings = ret.data['Settings']['UserSettings'];
          this.mandantConfig = ret.data['MandantConfig'];
          this.enumertion = ret.data['Enumeration'];

          this.Clients = ret.data['Clients'];
          this.Companies = ret.data['Companies'];
          this.AllSettings = {};
          for (const x of ret.data['AllSettings']) {
            const no = {
              Client: x['Client']
              , ClientID: x['ClientID']
              , CompanyID: x['CompanyID']
              , Company: x['Company']
              , Defaults: {}
              , Settings: null
            };
            if (x['Defaults'] !== null) {
              no['Defaults'] = JSON.parse(x['Defaults']);
            }
            if (x['MandantSettings'] !== null) {
              no['Settings'] = JSON.parse(x['MandantSettings']);
            }
            this.AllSettings[x['ClientID']] = no;
          }
        } else {
          this.defaults = ret.data['Defaults'];
          this.mandantSettings = ret.data['MandantSettings'];
          this.userSettings = ret.data['UserSettings'];
          this.mandantConfig = ret.data['MandantConfig'];
          this.enumertion = ret.data['Enumeration'];
        }
        if (this.userSettings !== undefined && this.userSettings !== 'undefined' && this.userSettings !== null) {
          this.UserSettings = JSON.parse(this.userSettings);
        } else {
          this.UserSettings = {};
          Object.assign(this.UserSettings, this.userSettingsDefault);
        }
        if (this.mandantSettings !== undefined && this.mandantSettings !== 'undefined' && this.mandantSettings !== null) {
          this.MandantSettings = JSON.parse(this.mandantSettings);
        }
        if (this.MandantSettings.Currency === undefined) {
          this.MandantSettings.Currency = {Format: '0.2-2', Symbol: 'EUR', Culture: 'de'};
        }
        if (this.MandantSettings.ReviewGroup === undefined) {
          this.MandantSettings.ReviewGroup = {AllowFreeText: true, AllowManualMode: true, AllowWizardMode: true};
        }
        if (this.MandantSettings.ReviewSettings === undefined) {
          this.MandantSettings.ReviewSettings = {FullTextCode: false};
        }
        if (this.MandantSettings.AuditTypes === undefined) {
          this.MandantSettings.AuditTypes = {
            Digital: {
              Visible: true,
              Quota: {Text: null, Visible: true},
              Complete: {Text: null, Visible: true},
              Picked: {Text: null, Visible: true},
              Rating: {Text: null, Visible: true}
            }, Physical: {Visible: true}
          };
        }
        if (this.MandantSettings.LocationsEnabled === undefined) {
          this.MandantSettings.LocationsEnabled = false;
        }
        if (this.MandantSettings.ForceComments === undefined) {
          this.MandantSettings.ForceComments = true;
        }
        if (this.defaults !== undefined && this.defaults !== 'undefined' && this.defaults !== null) {
          this.Defaults = JSON.parse(this.defaults);
        }
        if (this.mandantConfig !== null) {
          this.MandantConfig = JSON.parse(this.mandantConfig);
        }
        if (this.enumertion !== null) {
          this.Enumeration = JSON.parse(this.enumertion);
        }

        const x = {
          M: this.MandantSettings,
          U: this.UserSettings,
          D: this.Defaults,
          Co: this.Companies,
          Cli: this.Clients,
          AS: this.AllSettings
        };
        const j = JSON.stringify(x);
        localStorage.setItem('excDss', j);
      }      catch { }
      this.alreadyRunning = false;
    });
  }
}
@Pipe({name: 'ExcCurrency'})
@Injectable()
export class ExcCurrency implements PipeTransform {
  constructor(private excDss: DefaultSettingsService, private currencyPipe: CurrencyPipe) {

  }
  transform(value: any, ...args): any {
    if (this.excDss.MandantSettings && this.excDss.MandantSettings.Currency) {
      if (value !== null) {
        return this.currencyPipe.transform(value, this.excDss.MandantSettings.Currency.Symbol, 'symbol', this.excDss.MandantSettings.Currency.Format, this.excDss.MandantSettings.Currency.Culture);
      }
      return this.currencyPipe.transform(0, this.excDss.MandantSettings.Currency.Symbol, 'symbol', this.excDss.MandantSettings.Currency.Format, this.excDss.MandantSettings.Currency.Culture);
    } else {
      if (value !== null) {
        return this.currencyPipe.transform(value, 'EUR', 'symbol', '0.2-2', 'de');
      }
      return this.currencyPipe.transform(0, 'EUR', 'symbol', '0.2-2', 'de');
    }
  }
}
@Pipe({name: 'ExcOrderBy'})
@Injectable()
export class ExcOrderBy implements  PipeTransform {
  value: string[] = [];

  static _orderByComparator(a: any, b: any): number {

    if (a === null || typeof a === 'undefined') a = 0;
    if (b === null || typeof b === 'undefined') b = 0;

    if (isBoolean(a)) {
      a = a ? 1 : 0;
    }
    if (isBoolean(b)) {
      b = b ? 1 : 0;
    }
    if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))){
      if (a.toLowerCase() < b.toLowerCase()) return -1;
      if (a.toLowerCase() > b.toLowerCase()) return 1;
    } else {
      if (parseFloat(a) < parseFloat(b)) return -1;
      if (parseFloat(a) > parseFloat(b)) return 1;
    }

    return 0;
  }

  transform(input:any, config:string = '+'): any {

    this.value = [...input];
    let value = this.value;

    if (!Array.isArray(value)) return value;

    if (!Array.isArray(config) || (Array.isArray(config) && config.length === 1)) {
      let propertyToCheck: string = !Array.isArray(config) ? config : config[0];
      let desc = propertyToCheck.substr(0, 1) === '-';

      //Basic array
      if (!propertyToCheck || propertyToCheck === '-' || propertyToCheck === '+') {
        return !desc ? value.sort() : value.sort().reverse();
      } else {
        let property: string = propertyToCheck.substr(0, 1) === '+' || propertyToCheck.substr(0, 1) === '-'
          ? propertyToCheck.substr(1)
          : propertyToCheck;

        return value.sort(function (a: any, b: any) {
          return !desc
            ? ExcOrderBy._orderByComparator(a[property], b[property])
            : -ExcOrderBy._orderByComparator(a[property], b[property]);
        });
      }
    } else {
      return value.sort(function (a: any, b: any) {
        for (let i: number = 0; i < config.length; i++) {
          let desc = config[i].substr(0, 1) === '-';
          let property = config[i].substr(0, 1) === '+' || config[i].substr(0, 1) === '-'
            ? config[i].substr(1)
            : config[i];

          let comparison = !desc
            ? ExcOrderBy._orderByComparator(a[property], b[property])
            : -ExcOrderBy._orderByComparator(a[property], b[property]);

          if (comparison !== 0) return comparison;
        }

        return 0;
      });
    }
  }
}
export class ExcClientSettings {
  public Labels: any;
  public Currency: { Format: string, Symbol: string, Culture: string } = {
    Format: '0.2-2',
    Symbol: 'EUR',
    Culture: 'de'
  };
  public ReviewGroup: { AllowManualMode: boolean, AllowWizardMode: boolean, AllowFreeText: boolean } = {
    AllowManualMode: true,
    AllowWizardMode: true,
    AllowFreeText: true
  };
  public ForceComments = false;
  public DirectAssignAudits = false;
  public LocationsEnabled = false;
  public DigitalDocumentTypes: {Type: string, Value: number}[] = [{Type: 'Selfcheck', Value: 16}];
  public AuditPlanning: { Types: { Icon: string, Short: string, Key: string, Title: string, Color: string }[] } = {Types: []};
  public ReviewSettings: {FullTextCode: boolean} = {FullTextCode: false};
  public AuditTypes: {Digital: {Visible: boolean, Quota: {Text: null, Visible: boolean}, Complete: {Text: null, Visible: boolean}, Picked: {Text: null, Visible: boolean}, Rating: {Text: null, Visible: boolean}},
  Physical: {Visible: boolean}} =
    {Digital: {Visible: true, Quota: {Text: null, Visible: true}, Complete: {Text: null, Visible: true}, Picked: {Text: null, Visible: true} , Rating: {Text: null, Visible: true}}, Physical: {Visible: true}};
  constructor() {

  }

  public Apply(loaded: any) {
    Object.assign(this, loaded);
  }
}
interface IClientConfig {
  Defaults: any;
  Settings: ExcClientSettings;
  Client: string;
  ClientID: number;
  CompanyID: number;
  Company: string;

}
